(function() {
  'use strict';

  var root = document.querySelector('.d3x-root');
  if (!root) return;

  // ===== Reveal-on-scroll =====
  if ('IntersectionObserver' in window) {
    root.classList.add('js-reveal');
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    root.querySelectorAll('.reveal').forEach(function(el) { revealObserver.observe(el); });
    setTimeout(function() {
      root.querySelectorAll('.reveal:not(.in)').forEach(function(el) { el.classList.add('in'); });
    }, 2500);
  }

  // ===== Carousel =====
  var track = document.getElementById('carouselTrack');
  var dots = root.querySelectorAll('.carousel-dot');
  if (track && dots.length) {
    function setActiveDot(idx) {
      dots.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
    }
    var scrollTimer;
    track.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        setActiveDot(idx);
      }, 60);
    });
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setActiveDot(i);
      });
    });
  }

  // ===== Lightbox (tap-to-zoom carousel) =====
  var lightbox = document.getElementById('lightbox');
  var lightboxStage = document.getElementById('lightboxStage');
  var lightboxClose = document.getElementById('lightboxClose');
  var lightboxCounter = document.getElementById('lightboxCounter');

  if (lightbox && lightboxStage && lightboxClose) {
    var lightboxPanes = lightboxStage.querySelectorAll('.lightbox-pane');
    var totalPanes = lightboxPanes.length;

    function openLightbox(idx) {
      lightbox.classList.add('open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lightbox-open');
      try {
        lightboxStage.scrollTo({ left: idx * lightboxStage.clientWidth, behavior: 'instant' });
      } catch (e) {
        lightboxStage.scrollLeft = idx * lightboxStage.clientWidth;
      }
      updateCounter(idx);
    }
    function closeLightbox() {
      lightbox.classList.remove('open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lightbox-open');
    }
    function updateCounter(idx) {
      if (lightboxCounter) lightboxCounter.textContent = (idx + 1) + ' / ' + totalPanes;
    }

    root.querySelectorAll('.carousel-slide').forEach(function(slide, idx) {
      slide.addEventListener('click', function() { openLightbox(idx); });
    });

    lightboxClose.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox || e.target === lightboxStage) closeLightbox();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox.classList.contains('open')) closeLightbox();
    });

    var lbScrollTimer;
    lightboxStage.addEventListener('scroll', function() {
      clearTimeout(lbScrollTimer);
      lbScrollTimer = setTimeout(function() {
        var idx = Math.round(lightboxStage.scrollLeft / lightboxStage.clientWidth);
        updateCounter(idx);
      }, 60);
    });
  }

  // ===== QA accordion =====
  root.querySelectorAll('.qa-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.parentElement;
      var open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open);
    });
  });

  // ===== Buy form: plan switching + cart submission =====
  var form = document.getElementById('d3xProductForm');
  if (form) {
    var planRadios = form.querySelectorAll('input[name="selling_plan"]');

    // When plan changes, just let the radio state update — the form submission picks up the value.
    // (Visual price updates are handled by CSS/Liquid since prices are pre-rendered per plan.)

    // Submit handler — POST to /cart/add via AJAX, then redirect to /cart on success.
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var btn = form.querySelector('.buy-cta');
      if (btn && btn.disabled) return;
      if (btn) {
        btn.classList.add('is-loading');
        btn.disabled = true;
      }

      var formData = new FormData(form);
      // Empty selling_plan means one-time purchase; remove it so Shopify doesn't reject.
      if (formData.get('selling_plan') === '' || formData.get('selling_plan') === null) {
        formData.delete('selling_plan');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function() {
        // Success — go to cart. Replace with a drawer-open call if/when you wire one in.
        window.location.href = '/cart';
      })
      .catch(function(err) {
        console.error('[D3X cart]', err);
        if (btn) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        }
        alert('Sorry — something went wrong adding to cart. Please try again.');
      });
    });
  }
})();
